import { Button, Modal } from 'flowbite-react'
import { HiOutlineExclamationCircle } from 'react-icons/hi'

interface ComponenteDeCreditoModalProps {
  isOpen: boolean | false
  onClose: any
  onSubmit: () => void
}

const ConfirmarCreditoModal = ({
  isOpen,
  onClose,
  onSubmit
}: ComponenteDeCreditoModalProps) => {
  return (
    <Modal show={isOpen} onClose={onClose} size='md' >
      <Modal.Body>
        <div className='text-center'>
          <HiOutlineExclamationCircle className='mx-auto mb-4 h-14 w-14 text-yellow-400' />
          <h3 className='mb-0 text-md font-bold text-gray-600'>
            Deseja enviar este pedido para compra?
          </h3>
          <p className='text-sm text-gray-500 mb-5'>
            Essa ação não poderá ser desfeita.
          </p>
          <div className='flex justify-center gap-4'>
            <Button color="gray" onClick={onClose}>
              Cancelar
            </Button>
            <Button onClick={onSubmit}>
              Confirmar
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ConfirmarCreditoModal